export default __webpack_public_path__ + "static/media/img2.6bf62df7.jpg";